import React, {FC, ReactNode} from 'react';
import {s} from "./PDFOrder";
import {Image, Text, View} from "@react-pdf/renderer";
import {getProductById} from "../../helpers/helpers";
import CartItemOptions from "./CartItemOptions";
import {CartItemFrontType} from "../../helpers/cartTypes";

const PdfTableNoPrice:FC<{cart: CartItemFrontType[], children?: ReactNode}> = ({cart}) => {
    return (
        <View style={s.table}>
            <View style={s.cartItem}>
                <View style={s.th0_short}><Text>#</Text></View>
                <View style={s.th1_short}><Text>Img</Text></View>
                <View style={s.th2_short}><Text>Description</Text></View>
            </View>
            {cart.map((el, index) => {
                const {product_id, product_type, isStandard, exact_image} = el;
                const product = getProductById(product_id, product_type === 'standard');
                if (!product) return null;
                const {name} = product;
                const anyNotStandard = Object.values(isStandard).some(value => !value) || Object.values(isStandard.dimensions).some(value => !value);
                return (
                    <View wrap={false} style={s.cartItem} key={index}>
                        <View style={s.th0_short}><Text>{++index}</Text></View>
                        <View style={s.img_short}>
                            <Image src={exact_image}/>
                        </View>
                        <View style={s.data_short}>
                            <Text style={s.itemName}>
                                <Text>{name}</Text> {anyNotStandard && <Text style={s.non}>Custom</Text>}
                            </Text>
                            <CartItemOptions item={el}/>
                            {el.note ? <Text style={s.note}>*{el.note}</Text> : null}
                        </View>
                    </View>
                )
            })}
        </View>
    );
};

export default PdfTableNoPrice;